export default "__VITE_ASSET__DbCU53jw__"